import { deepClone } from ".";

export function getOffset(element) {
    return window.jQuery(element).offset();
    if (!element.getClientRects().length) {
        return { top: 0, left: 0 };
    }

    let rect = element.getBoundingClientRect();
    let win = element.ownerDocument.defaultView;

    return (
        {
            top: rect.top + win.pageYOffset,
            left: rect.left + win.pageXOffset
        });
}


export function setOffset(el, offset) {
    return window.jQuery(el).offset(offset);
    var rect = getOffset(el);
    var scrollLeft = document.documentElement.scrollLeft;
    var scrollTop = document.documentElement.scrollTop;

    el.style.position = 'absolute';
    el.style.left = (offset.left - rect.left + scrollLeft) + 'px';
    el.style.top = (offset.top - rect.top + scrollTop) + 'px';
}

export function drawLine(stem, option, color = 'var(--mui-palette-primary-main)', dotted = false) {

    let pointA = getOffset(stem)
    pointA.left = pointA.left + stem.offsetWidth;
    pointA.top = pointA.top + stem.offsetHeight / 2;

    let pointB = getOffset(option);

    pointB.top = pointB.top + option.offsetHeight / 2;
    let angle = Math.atan2(pointB.top - pointA.top, pointB.left - pointA.left) * 180 / Math.PI;
    let distance = lineDistance(
        pointA.left,
        pointA.top,
        pointB.left,
        pointB.top
    );

    let line = Object.assign(document.createElement('div'), { classList: 'line highlighted' })
    // arrow = Object.assign(document.createElement('div'), { classList: 'point' });

    // line.appendChild(arrow);
    line.setAttribute("data-stem", stem.getAttribute("id"));
    line.setAttribute("data-option", option.getAttribute("id"));

    document.querySelector(".questions").appendChild(line);

    line.style.transform = "rotate(" + angle + "deg)";
    line.style.width = distance + "px";
    line.style.position = "absolute";
    line.style.backgroundColor = '#FFC74A';
    line.style.height = '2px';
    line.style.zIndex = '0'

    // arrow.style.borderLeft = '16px solid ' + '#FFC74A';

    if (dotted) {
        line.style.border = '2px dashed ' + color;
        line.style.backgroundColor = 'transparent';
        line.style.boxShadow = 'none';
        line.style.height = '0px';
    }

    if (pointB.top > pointA.top) {
        setOffset(line, { top: (pointA.top), left: (pointA.left) })
    } else {
        setOffset(line, { top: (pointB.top), left: (pointA.left) })
    }

    // Create the line
    // let line = document.createElement('div');
    // line.classList.add('line', 'highlighted');
    // line.setAttribute("data-stem", stem.getAttribute("id"));
    // line.setAttribute("data-option", option.getAttribute("id"));

    // // Create start and end dots
    // let startDot = document.createElement('div');
    // startDot.classList.add('dot');
    // startDot.setAttribute("data-stem", stem.getAttribute("id"));
    // startDot.setAttribute("data-option", option.getAttribute("id"));

    // let endDot = document.createElement('div');
    // endDot.classList.add('dot');
    // endDot.setAttribute("data-stem", stem.getAttribute("id"));
    // endDot.setAttribute("data-option", option.getAttribute("id"));

    // // Append line and dots to the DOM
    // document.querySelector(".questions").appendChild(line);
    // document.querySelector(".questions").appendChild(startDot);
    // document.querySelector(".questions").appendChild(endDot);

    // // Style the line
    // line.style.transform = "rotate(" + angle + "deg)";
    // line.style.width = distance + "px";
    // line.style.position = "absolute";
    // line.style.backgroundColor = '#FFC74A';
    // line.style.height = '2px';
    // line.style.zIndex = '0';

    // if (dotted) {
    //     line.style.border = '2px dashed ' + color;
    //     line.style.backgroundColor = 'transparent';
    //     line.style.boxShadow = 'none';
    //     line.style.height = '0px';
    // }

    // // Style the dots
    // startDot.style.width = '6px';
    // startDot.style.height = '6px';
    // startDot.style.backgroundColor = '#FFC74A';
    // startDot.style.borderRadius = '50%';
    // startDot.style.position = 'absolute';
    // startDot.style.zIndex = '1';

    // endDot.style.width = '6px';
    // endDot.style.height = '6px';
    // endDot.style.backgroundColor = '#FFC74A';
    // endDot.style.borderRadius = '50%';
    // endDot.style.position = 'absolute';
    // endDot.style.zIndex = '1';

    // // Position the line and dots
    // if (pointB.top > pointA.top) {
    //     setOffset(line, { top: pointA.top, left: pointA.left });
    //     setOffset(startDot, { top: pointA.top - 3, left: pointA.left - 3 });
    //     setOffset(endDot, { top: pointB.top - 3, left: pointB.left - 3 });
    // } else {
    //     setOffset(line, { top: pointB.top, left: pointA.left });
    //     setOffset(startDot, { top: pointA.top - 3, left: pointA.left - 3 });
    //     setOffset(endDot, { top: pointB.top - 3, left: pointB.left - 3 });
    // }

    // let line = Object.assign(document.createElement('div'), { classList: 'line highlighted' }),
    //     arrow = Object.assign(document.createElement('div'), { classList: 'point' });

    // line.appendChild(arrow);
    // line.setAttribute("data-stem", stem.getAttribute("id"));
    // line.setAttribute("data-option", option.getAttribute("id"));

    // document.querySelector(".questions").appendChild(line);

    // line.style.transform = "rotate(" + angle + "deg)";
    // line.style.width = distance + "px";
    // line.style.position = "absolute";
    // line.style.backgroundColor = '#FFC74A';
    // line.style.height = '2px';
    // line.style.zIndex = '0'

    // arrow.style.borderLeft = '16px solid ' + '#FFC74A';

    // if (dotted) {
    //     line.style.border = '2px dashed ' + color;
    //     line.style.backgroundColor = 'transparent';
    //     line.style.boxShadow = 'none';
    //     line.style.height = '0px';
    // }

    // if (pointB.top > pointA.top) {
    //     setOffset(line, { top: (pointA.top), left: (pointA.left) })
    // } else {
    //     setOffset(line, { top: (pointB.top), left: (pointA.left) })
    // }
}

export function lineDistance(x, y, x0, y0) {
    return Math.sqrt((x -= x0) * x + (y -= y0) * y);
}

export const evaluateMTF = (left, right, answers, totalMarks) => {
    // let ans,
    //     score = 0, scorePerAns = (totalMarks / left.length);

    // if (answers && Object.keys(answers).length) {
    //     ans = Object.values(answers)[0];
    // } else {
    //     ans = {};
    // }

    // const rightCopy = right.map(item => ({ ...item }));
    // const leftCopy = left.map(item => ({ ...item }));
    // const ansCopy = deepClone(ans)

    // rightCopy.forEach((item, ind) => {

    //     let ansLabel = item['label'],
    //         matchedWith = '';

    //     Object.keys(ans).forEach(key => {
    //         if (ans[key]['labels']?.includes(ansLabel)) {
    //             matchedWith = key;
    //         }
    //     });

    //     let match = leftCopy.find(elem => elem.label == matchedWith);

    //     if (match && match.answerLabels.includes(ansLabel)) {
    //         rightCopy[ind]['correct'] = true;
    //         ansCopy[matchedWith]['lineColor'] = 'green';
    //         ansCopy[matchedWith]['correct'] = true;

    //         score += scorePerAns;
    //     } else if (matchedWith) {
    //         rightCopy[ind]['correct'] = false;
    //         ansCopy[matchedWith]['lineColor'] = 'red';
    //         ansCopy[matchedWith]['correct'] = false;
    //         ansCopy[matchedWith]['answerLabels'] = match.answerLabels
    //     } else {
    //         let it = leftCopy[ind];
    //         if (!it) return;

    //         ansCopy[it['label']] = {};

    //         ansCopy[it['label']]['correct'] = false;
    //         ansCopy[it['label']]['answerLabels'] = it.answerLabels;
    //     }

    // });

    // return { score, left: leftCopy, right: rightCopy, ans: ansCopy }
    let ans,
        score = 0, scorePerAns = (totalMarks / left.length);

    if (answers && Object.keys(answers).length) {
        ans = Object.values(answers)[0];
    } else {
        ans = {};
    }

    const rightCopy = right.map(item => ({ ...item }));
    const leftCopy = left.map(item => ({ ...item }));
    const ansCopy = deepClone(ans)

    rightCopy.forEach((item, ind) => {

        let ansLabel = item['label'],
            matchedWith = '';

        Object.keys(ans).forEach(key => {
            // Add null check for labels
            if (ans[key] && ans[key]['labels'] && Array.isArray(ans[key]['labels']) && ans[key]['labels'].includes(ansLabel)) {
                matchedWith = key;
            }
        });

        let match = leftCopy.find(elem => elem.label == matchedWith);

        // Add null check for answerLabels
        if (match && match.answerLabels && Array.isArray(match.answerLabels) && match.answerLabels.includes(ansLabel)) {
            rightCopy[ind]['correct'] = true;
            ansCopy[matchedWith]['lineColor'] = 'green';
            ansCopy[matchedWith]['correct'] = true;

            score += scorePerAns;
        } else if (matchedWith) {
            rightCopy[ind]['correct'] = false;
            ansCopy[matchedWith]['lineColor'] = 'red';
            ansCopy[matchedWith]['correct'] = false;
            ansCopy[matchedWith]['answerLabels'] = match ? match.answerLabels : [];
        } else {
            let it = leftCopy[ind];
            if (!it) return;

            ansCopy[it['label']] = {};

            ansCopy[it['label']]['correct'] = false;
            ansCopy[it['label']]['answerLabels'] = it.answerLabels || [];
        }

    });

    return { score, left: leftCopy, right: rightCopy, ans: ansCopy }
}